module.exports = __webpack_public_path__ + "static/product-l0810-coyote-tan-a4c89273407212fd79df34954785b147.png";